import React from 'react';
import { NavLink } from 'react-router-dom';
import SEO from '../components/SEO';
import { COMPANY_INFO } from '../data/siteData';

export default function ForbiddenPage() {
  return (
    <>
      <SEO
        title="403 - Manglende adgang - CMSNord.dk"
        description="Du har ikke adgang til denne ressource på CMSNord.dk."
      />

      <section className="min-h-[60vh] bg-slate-900 py-20 flex items-center justify-center">
        <div className="max-w-xl mx-auto px-4 text-center">
          <div className="w-20 h-20 rounded-2xl bg-rose-500/10 border border-rose-500/30 text-rose-400 flex items-center justify-center text-4xl mx-auto mb-6">
            <i className="fa-solid fa-lock" aria-hidden="true" />
          </div>

          <h1 className="text-4xl sm:text-5xl font-black text-white mb-3">403 - Ingen adgang</h1>
          <p className="text-slate-300 text-base leading-relaxed mb-8">
            Du har ikke tilladelse til at tilgå den anmodede side eller ressource.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <NavLink
              to="/"
              className="px-6 py-3 rounded-lg bg-amber-600 hover:bg-amber-500 text-white font-bold text-sm uppercase tracking-wider transition-all"
            >
              Gå til Forsiden
            </NavLink>

            <NavLink
              to="/kontakt"
              className="px-6 py-3 rounded-lg bg-slate-800 hover:bg-slate-700 text-white font-bold text-sm uppercase tracking-wider border border-slate-700 transition-all"
            >
              Kontakt Support
            </NavLink>
          </div>

          <div className="mt-8 pt-6 border-t border-slate-800 text-xs text-slate-400">
            Telefon support:{' '}
            <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="nowrap-contact font-bold text-amber-400 hover:underline">
              {COMPANY_INFO.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
